import Vue from 'vue';
import store from '@/vuex/store';
import '@/style/main.scss';
import '@/registerServiceWorker';
import axios from 'axios';
import VueAxios from 'vue-axios';
import GAuth from 'vue-google-oauth2';
import VueFB from '@/helpers/fb-sdk-plugin';
import '../node_modules/leaflet/dist/leaflet.css';
import '../node_modules/leaflet.markercluster/dist/MarkerCluster.css';
import VueMq from 'vue-mq';
import VTooltip from 'v-tooltip';
import { router } from './router';
import App from './App.vue';
import config from '@/config';

Vue.use(VueAxios, axios);

Vue.use(GAuth, {
  clientId: config.google.clientId,
  scope: 'https://www.googleapis.com/auth/plus.me',
});

Vue.use(VueMq, {
  breakpoints: {
    xs: 500,
    mobile: 768,
    tablet: 1024,
    laptop: 1280,
    desktop: 1600,
    main: Infinity,
  },
});

Vue.use(VueFB, {
  appId: config.facebook.appId,
  cookie: true,
  xfbml: true,
  version: 'v3.2',
});

Vue.use(VTooltip, {
  defaultDelay: 150,
});

const VueInputMask = require('vue-inputmask').default;

Vue.use(VueInputMask);

Vue.config.productionTip = false;
export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
